import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './login.css'; // Import CSS từ file riêng

const LoginApp = () => {
  // State management
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [shakeForm, setShakeForm] = useState(false);
  
  // Hook để chuyển hướng
  const navigate = useNavigate();

  // Thông tin đăng nhập cứng
  const validUsers = {
    'demo': 'demone'
  };

  // Kiểm tra session khi component mount
  useEffect(() => {
    const savedLoginState = sessionStorage.getItem('loggedIn');
    const savedUsername = sessionStorage.getItem('username');
    
    if (savedLoginState === 'true' && savedUsername) {
      // Nếu đã đăng nhập rồi thì chuyển thẳng đến UploadFile
      navigate('/upload-file');
    }
  }, [navigate]);

  // Kiểm tra thông tin đăng nhập
  const validateLogin = (username, password) => {
    return validUsers.hasOwnProperty(username) && validUsers[username] === password;
  };

  // Xử lý đăng nhập
  const handleLogin = () => {
    setErrorMessage('');

    const trimmedUsername = username.trim();
    
    if (validateLogin(trimmedUsername, password)) {
      // Lưu vào session storage
      sessionStorage.setItem('loggedIn', 'true');
      sessionStorage.setItem('username', trimmedUsername);
      
      // Chuyển hướng đến trang UploadFile
      navigate('/upload-file');
    } else {
      setErrorMessage('Tên đăng nhập hoặc mật khẩu không đúng!');
      setShakeForm(true);
      setTimeout(() => setShakeForm(false), 500);
    }
  };

  // Xử lý phím Enter
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  // Render Login Form
  return (
    <div className="app">
      <div className="login-container">
        <div className={`login-box ${shakeForm ? 'shake' : ''}`}>
          <h2>Đăng nhập</h2>
          <div>
            <div className="input-group">
              <label htmlFor="username">Tên đăng nhập:</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyPress={handleKeyPress}
                autoComplete="username"
                placeholder="Nhập tên đăng nhập"
              />
            </div>
            <div className="input-group">
              <label htmlFor="password">Mật khẩu:</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
                autoComplete="current-password"
                placeholder="Nhập mật khẩu"
              />
            </div>
            <button onClick={handleLogin} className="login-button">
              Đăng nhập
            </button>
            {errorMessage && (
              <div className="error-message show">
                {errorMessage}
              </div>
            )}
          </div>
          <div className="demo-info">
            <p><strong>Thông tin đăng nhập demo:</strong></p>
            <p>Username: demo | Password: demone</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginApp;